declare const window :any;

export const footer = ()=>{
    window.backToTop(document.querySelector('footer'),'.backtotop');
}